import React from "react";
import { connect } from "react-redux";
import {getLoanFiles,addFileToLoan, deleteLoanFile} from 'store/state/loan/loan';
import AttachmentsDrawer from 'components/Global/Attachments/AttachmentsDrawer';
import _ from 'lodash';

class LoanAttachments extends React.Component {

  componentDidUpdate(prevProps, prevState){
    const { loanId,isOpen} = this.props;
    const {isOpen: prevIsOpen} = prevProps;
    if(isOpen !== prevIsOpen && isOpen){
      this.props.getLoanFiles({
        modelName: 'loan',
        modelId:loanId,
        subKey: loanId
      })
    }
  }

  handleRemoveFile = (fileId) => {
    const {loanId} = this.props;
    this.props.deleteLoanFile({
      fileId: fileId, 
      shouldUpdateAfter:true, 
      modelName: 'loan',
      modelId: loanId,
      subKey:loanId });
  }

  render() {
    const {isOpen, closeAttachments, loanFiles, loanId,addFileToLoan, isLoading} = this.props;    
    const specificLoanFiles = loanFiles[loanId] || [];

    return (
      <React.Fragment>
        <AttachmentsDrawer
        internalID = {"forLoan"+loanId}
          drawerWidth={600}
          addFile={(file) => addFileToLoan('loan', loanId, file)}
          isOpen={isOpen}
          isLoading={isLoading}
          closeDrawer={closeAttachments}
          files={specificLoanFiles} 
          handleRemove={this.handleRemoveFile}/>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ loan, loading}) => ({
  loanFiles: loan.loanFiles,
  isLoading: loading.loan_file_upload
});

export default connect(
  mapStateToProps,
  {   
    getLoanFiles,
    addFileToLoan,
    deleteLoanFile
  }
)(LoanAttachments);

